import React from "react";

// components
import { AppointmentCollapsibleCard } from "./Common";
import { getDwk } from "bodycodi/cmap/app/js/common";

const AppointmentTab = ({ details }: any) => {
  const ALLOWANCE_TYPE: any = {
    AMOUNT: "정액제",
    RATE: "정률제",
  };

  const ALLOWANCE_BASE_TYPE: any = {
    SALESPRICE: "판매금액 기준",
    PAYMENTAMOUNT: "결제금액 기준",
  };

  const ALLOWANCE_VAT_YN: any = {
    Y: "부가세 포함 후 정산",
    N: "부가세 제외 후 정산",
  };

  return (
    <div className="tab-content">
      <span className="tab-title">개인레슨 수당</span>

      <div className="section">
        <span>수당 지급 방식</span>
        <span>{details?.allowanceType ? ALLOWANCE_TYPE[details?.allowanceType] : "미설정"}</span>
      </div>

      <div className="section">
        <span>수당 대상 금액 기준</span>
        <span>
          {details?.allowanceBaseType ? ALLOWANCE_BASE_TYPE[details?.allowanceBaseType] : "미설정"}
        </span>
      </div>

      <div className="section">
        <span>부가세 포함여부</span>
        <span>
          {details?.allowanceVatYn ? ALLOWANCE_VAT_YN[details?.allowanceVatYn] : "미설정"}
        </span>
      </div>

      <div className="section">
        <span>차감된 결석 정산</span>
        <span>
          {details?.appointmentAbsentApplyType
            ? details?.appointmentAbsentApplyType === "Y"
              ? `출석 정산 금액의 ${details?.appointmentAbsentApplyRate}%`
              : "정산하지않음"
            : "미설정"}
        </span>
      </div>

      <div className="section no-margin">
        <span>시간 외 수당</span>
        <span>
          {details?.nonWorkHourYn
            ? details?.nonWorkHourYn === "Y"
              ? `${details?.nonWorkHourRate}배수로 지급`
              : "반영하지 않음"
            : "미설정"}
        </span>
      </div>

      {details?.coachWorkHours.length > 0 && <ScheduleTable list={details?.coachWorkHours} />}

      <div className="table-title with-count">
        수당 설정 이용권
        <span>{details?.pricings?.length ? `${details?.pricings?.length}건` : "미설정"}</span>
      </div>

      {details?.pricings?.map((pricing: any, index: number) => {
        return (
          <AppointmentCollapsibleCard
            key={index}
            pricing={pricing}
            allowanceType={details?.allowanceType}
          />
        );
      })}
    </div>
  );
};

const ScheduleTable = ({ list }: any) => {
  return (
    <>
      <div className="table-title">수당 지급 대상 근무 시간 설정</div>
      <table className="schedule-table">
        <thead style={{ height: 36 }}>
          <tr>
            <th style={{ width: "13%", border: "none" }}>요일</th>
            <th colSpan={4} style={{ borderRight: "none" }}>
              시간
            </th>
          </tr>
        </thead>
        <tbody>
          {list?.map((day: any, index: number) => {
            return (
              <tr key={index}>
                <td className="gray-background">{getDwk(day?.dateType)}</td>
                <td
                  colSpan={4}
                >{`${day?.startDt}\u00A0\u00A0\u00A0\u00A0-\u00A0\u00A0\u00A0\u00A0${day?.endDt}`}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};

export default AppointmentTab;
